import * as React from 'react';
import * as classNames from 'classnames/bind';
import { Link } from 'react-static';

import { Language } from '../../containers/Localization/localizationDuck';

import styles from './LanguageSwitcher.scss';

const cx = classNames.bind(styles);

export interface Props {
  languages: { [lang in Language]: string };
  currentLanguage: string;
}

const LanguageSwitcher: React.SFC<Props> = ({ languages, currentLanguage }) => {
  const renderSwitchButton = (lang: string, href: string) => {
    const className = cx({
      button: true,
      selected: lang === currentLanguage,
    });

    return (
      <Link to={href} className={className} key={lang}>
        {lang}
      </Link>
    );
  };

  return (
    <div className="d-inline-flex align-items-center">
      {Object.entries(languages).map(([key, href]) => renderSwitchButton(key, href))}
    </div>
  );
};

export default LanguageSwitcher;



// WEBPACK FOOTER //
// /www/client/src/components/LanguageSwitcher/LanguageSwitcher.tsx